<ng-container *ngIf="isButtonVisible">
  <!-- Add our custom asterisk if this is in a required field -->
  <span *ngIf="isInRequiredField" class="custom-required-marker">*</span>
  
  <button
    mat-icon-button
    class="tooltip-button"
    (click)="openTooltip($event)"
    type="button"
  >
    <mat-icon class="tooltip-icon">help_outline</mat-icon>
  </button>
</ng-container>